function cookiepolicy() {
    $('#cookie-policy').hide()
    document.cookie = '_cookiepolicy=true; path=/; max-age=2592000;'
    return false
}

export function setupCookiePolicy(cookiePolicyUrl) {
    var text =
        'Ta witryna wykorzystuje pliki cookies. Korzystając ze strony wyrażają Państwo zgodę na używanie plików cookies zgodnie z aktualnymi ustawieniami przeglądarki. Możecie Państwo wyłączyć ten mechanizm w ustawieniach przeglądarki. Więcej informacji na ten temat znajda Państwo w ' +
        ' <a class="cookie-url" target="_blank" href="' +
        cookiePolicyUrl +
        '">Polityce prywatności</a>. '
    var link =
        '<a href="#" class="btn btn-primary cookie-url-accept">' +
        'OK' +
        '</a>'
    var cookiePolicyText =
        '<div class="cookie-policy" id="cookie-policy"><div class="container"><div class="row"><div class="col-md-8">' +
        text +
        '</div><div class="col-md-4">' +
        link +
        '</div></div></div></div>'

    if (document.cookie.indexOf('_cookiepolicy=true') === -1) {
        $('body')
            .append(cookiePolicyText)
        // .css('margin-bottom', '90px')
        $('.cookie-url-accept').on('click', function (e) {
            e.preventDefault()
            cookiepolicy()
        })
    }
}